// extracted by mini-css-extract-plugin
export default {"iconCard":"icon-card_iconCard__NbH1q","icon":"icon-card_icon__yiKTi"};